export const HOME_ROUTE = '/'
export const ADOPT_ROUTE = '/adopt'
export const ADD_APET_ROUTE = '/addpet'
export const ABOUT_ROUTE = '/about'
export const RESOURCE_CAT_ROUTE = '/cat'
export const RESOURCE_DOG_ROUTE = '/dog'
export const LOGIN_ROUTE = '/login'
export const SIGNUP_ROUTE = '/signup'
export const CONTACT_US_ROUTE = '/contactus'
export const DETAILS_ROUTE = '/details'
export const NOT_FOUND = '/not-found'
export const MY_PETS = '/mypets'
